module.exports = __webpack_public_path__ + "img/excited.60472739.png";